import type { Brand, Campaign, Person } from '../../supabase/functions/_shared/core/index.ts';
import type { Api } from './api.ts';

export interface Store {
  api: Api;
  /** Adresse de la personne connectée (démo : demo@…). */
  user: string;
  brands: Brand[];
  people: Person[];
  campaigns: Campaign[];
}

export async function loadStore(api: Api, user: string): Promise<Store> {
  const [brands, people, campaigns] = await Promise.all([
    api.listBrands(),
    api.listPeople(),
    api.listCampaigns(),
  ]);
  return { api, user, brands, people, campaigns };
}

export async function reload(store: Store): Promise<void> {
  Object.assign(store, await loadStore(store.api, store.user));
}

export type CampaignStatus = 'live' | 'upcoming' | 'past' | 'off';
/** Statut d'affichage ; une campagne sans dates (permanente) est « en cours » tant qu'elle est active. */
export function campaignStatus(c: Campaign, now = new Date()): CampaignStatus {
  if (!c.active) return 'off';
  if (c.ends_at && new Date(c.ends_at) <= now) return 'past';
  if (c.starts_at && new Date(c.starts_at) > now) return 'upcoming';
  return 'live';
}
export const STATUS_LABEL: Record<CampaignStatus, string> = {
  live: 'En cours',
  upcoming: 'À venir',
  past: 'Terminée',
  off: 'Désactivée',
};
